import React, { useEffect, useState } from "react";
import { PieChart, Pie, Cell, Tooltip, Legend, ResponsiveContainer } from "recharts";
import { searchDisk } from "../api/systemApi";
import grafana from "../grafanaFrame.png";

interface FileSystemData {
  filesystem: string;
  size: string;
  used: string;
  available: string;
  use_percent: number;
  mounted: string;
}

interface PieDataInfo {
  name: string;
  value: number;
  color: string;
  fsData: any;
}

const COLORS = ["#0088FE", "#00C49F", "#FFBB28", "#FF8042", "#A28BFE", "#FF6384"]; // 각 파일시스템 색상

const SystemAll = () => {
  // const [systemData, setSystemData] = useState<FileSystemData[]>([]);
  // const [selectedFs, setSelectedFs] = useState<FileSystemData | null>(null);
  // const [totalSize, setTotalSize] = useState<number>(0);
  // const [totalUsed, setTotalUsed] = useState<number>(0);
  // const [totalAvailable, setTotalAvailable] = useState<number>(0);
  // const [pieData, setPieData] = useState<PieDataInfo[]>([]);

  // useEffect(() => {
  //   diskSearch();
  // }, []);

  // const diskSearch = async () => {
  //   const data = await searchDisk("jaen");

  //   if (data.data) {
  //     console.log(data.data);
  //     setSystemData(data.data);
  //   }
  // };

  // useEffect(() => {
  //   // 데이터 변환: 전체 사용량과 여유 공간 계산
  //   if (systemData) {
  //     setTotalSize(
  //       systemData.reduce(
  //         (acc, cur) =>
  //           acc + cur.size.charAt(cur.size.length - 1) === "G" ? parseInt(cur.size) * 1000 : parseInt(cur.size),
  //         0
  //       )
  //     );
  //     setTotalUsed(
  //       systemData.reduce(
  //         (acc, cur) =>
  //           acc + cur.used.charAt(cur.used.length - 1) === "G" ? parseInt(cur.used) * 1000 : parseInt(cur.used),
  //         0
  //       )
  //     );
  //     setTotalAvailable(
  //       systemData.reduce(
  //         (acc, cur) =>
  //           acc +
  //           (cur.available.charAt(cur.available.length - 1) === "G"
  //             ? parseInt(cur.available) * 1000
  //             : parseInt(cur.available)),
  //         0
  //       )
  //     );

  //     setPieData([
  //       ...systemData.map((fs, index) => ({
  //         name: fs.filesystem,
  //         value: (fs.used.charAt(fs.used.length - 1) === "G" ? parseInt(fs.used) * 1000 : parseInt(fs.used)) / 1000,
  //         color: COLORS[index % COLORS.length],
  //         fsData: fs,
  //       })),
  //       {
  //         name: "남은 공간",
  //         value: totalAvailable / 1000, // 전체 남은 용량 추가
  //         color: "#D3D3D3", // 회색으로 표현
  //         fsData: "",
  //       },
  //     ]);
  //   }
  // }, [systemData, totalAvailable]);

  // const handleMouseEnter = (fs: FileSystemData) => {
  //   setSelectedFs(fs);
  // };

  // const handleMouseLeave = () => {
  //   setSelectedFs(null);
  // };

  // 그라파나 관리 관련
  const [isRefresh, setIsRefresh] = useState<boolean>(true);

  // useEffect(() => {
  //   if (isRefresh) {
  //     setTimeout(() => {
  //       setIsRefresh(false);
  //     }, 10000);
  //   } else {
  //     setIsRefresh(true);
  //   }
  // }, [isRefresh]);

  return (
    <div className="items-center justify-center text-center min-h-[50vh] min-w-[70vw] md:p-10 h-full">
      {/* <div className="flex flex-col items-center justify-center w-full p-4">
        <h2 className="mb-4 text-xl font-bold">📊 서버 파일시스템 용량 사용 현황</h2>
        <div className="relative w-full max-w-lg min-w-full">
          <ResponsiveContainer width="100%" height={400}>
            <PieChart>
              <Pie
                data={pieData}
                cx="50%"
                cy="50%"
                innerRadius={50}
                outerRadius={120}
                dataKey="value"
                minAngle={2}
                onMouseEnter={(data) => handleMouseEnter(data.fsData)}
                onMouseLeave={() => {
                  handleMouseLeave();
                }}
                label
              >
                {pieData.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={entry.color} />
                ))}
              </Pie>
              {/* <Tooltip /> }
              <Legend />
            </PieChart>
          </ResponsiveContainer>

          {/* 선택된 파일시스템 정보 표시 }
          {selectedFs && (
            <div className="absolute p-4 transform bg-white border rounded-lg shadow-md top-1/4 left-2/3">
              <h3 className="text-lg font-semibold">{selectedFs.filesystem}</h3>
              <p>📍 마운트 위치: {selectedFs.mounted}</p>
              <p>💾 총 용량: {selectedFs.size}</p>
              <p>📂 사용된 용량: {selectedFs.used}</p>
              <p>🗃️ 남은 용량: {selectedFs.available}</p>
              <p>📊 사용률: {selectedFs.use_percent}%</p>
            </div>
          )}
        </div>
      </div> */}
      {isRefresh ? (
        <div>
          <iframe
            src="https://monitoring.jaen.kr/d/eef2hbqo0ujuod/3656932?orgId=1&from=now-24h&to=now&timezone=browser&refresh=5s&kiosk"
            width="100%"
            height="777"
            frameborder="0"
            title="grafana"
          ></iframe>
        </div>
      ) : (
        <div>
          <img src={grafana} alt="" />
        </div>
      )}
    </div>
  );
};

export default SystemAll;
